// Navigation entre panneaux (gp), langue, validation P1 + handlers nx1/nx2/nx3.

import { S, UTM } from './state.js';
import { $, $$, clearE } from './dom.js';
import { EMAIL_RE, HOURS_PER_DAY } from './config.js';
import { apiPost } from './api.js';
import { renderSelModels, getTotalRobots } from './models.js';
import { renderQCal, updateDateUI, recomputeEndDate } from './calendar.js';
import { verifyEmailMX } from './email.js';

// Total number of steps in the active flow — read from the rendered
// stepper so the same gp() works for both maintenance (4) and service (6).
function stepCount() {
	var stepEls = document.querySelectorAll( '.probot-soum [id^="pt"]' );
	return Math.max( stepEls.length, 4 );
}

export function gp( n ) {
	var total = stepCount();
	for ( var i = 1; i <= total; i++ ) {
		var p = $( 'p' + i );
		if ( p ) p.classList.toggle( 'on', i === n );
		var t = $( 'pt' + i );
		if ( t ) {
			t.classList.remove( 'active', 'done' );
			if ( i === n )    t.classList.add( 'active' );
			else if ( i < n ) t.classList.add( 'done' );
		}
	}
	// Scroll vers le top du formulaire (pas du document) — sinon sur les pages
	// où le formulaire est précédé d'un hero/header, l'utilisateur ne voit
	// pas que la step a changé et croit que rien ne s'est passé.
	try {
		var form = document.querySelector( '.probot-soum' );
		var stepIndicator = $( 'pt' + n );
		var target = stepIndicator || form;
		if ( target && typeof target.getBoundingClientRect === 'function' ) {
			var rect = target.getBoundingClientRect();
			var top  = rect.top + ( window.pageYOffset || document.documentElement.scrollTop ) - 24;
			window.scrollTo( { top: Math.max( 0, top ), behavior: 'smooth' } );
		} else {
			window.scrollTo( { top: 0, behavior: 'smooth' } );
		}
	} catch ( e ) {}
}

export function setLang( l ) {
	S.lang = l;
	$$( '[data-ps-lang]' ).forEach( function ( b ) {
		b.classList.toggle( 'on', b.getAttribute( 'data-ps-lang' ) === l );
	} );
	$$( '.probot-soum .t' ).forEach( function ( el ) {
		var v = el.dataset[ l ];
		if ( v ) el.innerHTML = v;
	} );
	var ms = $( 'modelSearch' );
	if ( ms ) ms.placeholder = l === 'fr' ? 'Chercher un modèle… ex: R-2000' : 'Search a model… ex: R-2000';
	renderSelModels();
	if ( $( 'qcal' ) && $( 'qcal' ).childElementCount ) {
		renderQCal();
		updateDateUI();
	}
	// Re-render the AI estimate (number+unit+sidebar mini) so the singular/
	// plural day label follows the new locale.
	if ( S.service && S.service.analysisComplete && typeof window.ProbotSoumRerenderEstimate === 'function' ) {
		window.ProbotSoumRerenderEstimate();
	}
}

// v1.0.95 — Regex format téléphone NANP : 10 chiffres ou +1 + 10 chiffres,
// avec n'importe quels séparateurs (espaces, tirets, parenthèses, points).
var PHONE_NANP_RE = /^(\+?1[\s.\-]?)?\(?[2-9]\d{2}\)?[\s.\-]?[2-9]\d{2}[\s.\-]?\d{4}$/;

export function validateP1() {
	var ok = true;
	[
		{ f: 'f-fname',  i: 'inFname',  t: function ( v ) { return !! v; } },
		{ f: 'f-lname',  i: 'inLname',  t: function ( v ) { return !! v; } },
		{ f: 'f-title',  i: 'inTitle',  t: function ( v ) { return !! v; } },
		{ f: 'f-tel',    i: 'inTel',    t: function ( v ) { return PHONE_NANP_RE.test( v ); } },
		{ f: 'f-email',  i: 'inEmail',  t: function ( v ) { return EMAIL_RE.test( v ); } },
		{ f: 'f-co',     i: 'inCo',     t: function ( v ) { return !! v; } },
	].forEach( function ( rule ) {
		var v = ( $( rule.i ).value || '' ).trim();
		var err = ! rule.t( v );
		$( rule.f ).classList.toggle( 'err', err );
		if ( err ) ok = false;
	} );
	// v1.1.123 — L'adresse doit être une VRAIE adresse Google validée (S.placeId)
	// ET contenir un code postal (S.addressComponents.zip). Le code postal est
	// intégré dans l'adresse affichée (formatted_address), pas un champ séparé.
	var faEmpty = ! ( $( 'inFactoryAddress' ).value || '' ).trim();
	var faNoZip = ! ( S.addressComponents && S.addressComponents.zip );
	var faBad   = faEmpty || ! S.placeId || faNoZip;
	$( 'f-factory-address' ).classList.toggle( 'err', faBad );
	if ( faBad ) ok = false;

	// v1.0.95 — Si Twilio est activé ET configuré comme obligatoire, on bloque
	// le passage à Step 2 tant que le numéro n'est pas vérifié par SMS.
	var cfg = window.ProbotSoum || {};
	if ( cfg.phoneVerifyEnabled && cfg.phoneVerifyRequired && ! S.phoneVerified ) {
		var f = $( 'f-tel' );
		if ( f ) f.classList.add( 'err' );
		var em = f ? f.querySelector( '.emsg' ) : null;
		if ( em ) {
			em.textContent = S.lang === 'fr'
				? 'Veuillez vérifier votre numéro par SMS avant de continuer.'
				: 'Please verify your phone via SMS before continuing.';
			em.style.display = 'block';
		}
		ok = false;
	}

	// v1.0.97 — Consentement T&C obligatoire AVANT le transfert HubSpot/Twilio.
	// Loi 25 art. 8 / PIPEDA principe 4.3 / RGPD art. 6(1)(a) : il faut le
	// consentement explicite avant de collecter et transférer les données à un
	// tiers (HubSpot US via save-contact, Twilio US via verify-phone-send).
	var termsCb = $( 'psConsentTerms' );
	if ( termsCb && ! termsCb.checked ) {
		var termsErr = $( 'psConsentTermsErr' );
		if ( termsErr ) termsErr.style.display = 'block';
		if ( termsCb.scrollIntoView ) termsCb.scrollIntoView( { behavior: 'smooth', block: 'center' } );
		ok = false;
	} else {
		var termsErrHide = $( 'psConsentTermsErr' );
		if ( termsErrHide ) termsErrHide.style.display = 'none';
	}

	return ok;
}

export function nx1() {
	if ( ! validateP1() ) return;

	var btn = $( 'btnNx1' );
	var fr  = S.lang === 'fr';

	function proceed() {
		var contact = {
			event:        'contact_created',
			firstName:    $( 'inFname' ).value.trim(),
			lastName:     $( 'inLname' ).value.trim(),
			jobTitle:     $( 'inTitle' ).value.trim(),
			phone:        $( 'inTel'   ).value.trim(),
			email:        $( 'inEmail' ).value.trim(),
			company:      $( 'inCo'    ).value.trim(),
			address:      $( 'inFactoryAddress' ).value.trim(),
			place_id:     S.placeId || null,
			addr_street:  ( S.addressComponents && S.addressComponents.street )       || '',
			addr_city:    ( S.addressComponents && S.addressComponents.city )         || '',
			addr_zip:     ( S.addressComponents && S.addressComponents.zip )          || '',
			addr_state:   ( S.addressComponents && S.addressComponents.state_short )  || '',
			addr_country:       ( S.addressComponents && S.addressComponents.country )       || '',
		addr_country_code:  ( S.addressComponents && S.addressComponents.country_short ) || '',
			lang:         S.lang,
			source:       'configurateur-fanuc',
			utm_source:   UTM.utm_source,
			utm_medium:   UTM.utm_medium,
			utm_campaign: UTM.utm_campaign,
			utm_content:  UTM.utm_content,
			utm_term:     UTM.utm_term,
			gclid:        UTM.gclid,
			fbclid:       UTM.fbclid,
			// v1.1.53 — Click IDs additionnels pour Microsoft/Bing Ads + LinkedIn Ads
			// + referrer/landing_page pour multi-touch attribution complète.
			msclkid:      UTM.msclkid,
			li_fat_id:    UTM.li_fat_id,
			referrer:     UTM.referrer,
			landing_page: UTM.landing_page,
			hs_cookie:    UTM.hstc || '',
			website:      ( $( 'inWebsite' ) || {} ).value || '', // honey-pot
		};

		var origTxt = btn.innerHTML;
		btn.disabled  = true;
		btn.innerHTML = '<span class="spin" style="border-color:rgba(255,255,255,.3);border-top-color:#fff;vertical-align:middle;margin-right:6px"></span>' +
			( fr ? 'Enregistrement…' : 'Saving…' );

		apiPost( 'save-contact', contact, { recaptchaAction: 'save_contact' } )
			.catch( function ( e ) { console.warn( 'HubSpot save error:', e ); } )
			.finally( function () {
				btn.disabled  = false;
				btn.innerHTML = origTxt;
				gp( 2 );
			} );
	}

	// Si MX pas encore vérifié, on le fait maintenant et on bloque si invalide.
	if ( S.emailVerified === false ) {
		verifyEmailMX( $( 'inEmail' ).value.trim() );
		setTimeout( function () {
			if ( S.emailVerified === false ) return; // l'UI affiche déjà l'erreur
			proceed();
		}, 900 );
		return;
	}
	proceed();
}

// nx2 — leaving the Robot step.
// Maintenance (4 steps): robot OK → goes straight to Date (gp 3) and renders the calendar.
// Service     (6 steps): robot OK → goes to Describe (gp 3). Calendar comes later.
export function nx2() {
	if ( ! getTotalRobots() ) {
		var err = $( 'modelErr' ); if ( err ) err.classList.add( 'on' );
		return;
	}
	// Modèles inconnus → taille obligatoire
	if ( ( S.selModels.unknown || S.selModels.noinfonow ) && ! S.robotSize ) {
		$$( '[id^="sizeWarn-"]' ).forEach( function ( el ) { el.classList.add( 'on' ); } );
		var row = document.querySelector( '.sel-model-row' );
		if ( row ) row.scrollIntoView( { behavior: 'smooth', block: 'center' } );
		return;
	}
	if ( S.quoteType === 'service' ) {
		gp( 3 );
		return;
	}
	gp( 3 );
	renderQCal();
}

// nx3 — leaving the Describe step (service flow only).
// Validates the intervention type + a non-trivial description, then advances
// to the AI Triage step. The actual AI call is kicked off by the service
// panel binding when this transition happens.
export function nx3_describe() {
	var typeErr = $( 'f-svc-type' );
	var descErr = $( 'f-svc-desc' );
	var desc = ( ( $( 'inSvcDesc' ) || {} ).value || '' ).trim();

	if ( typeErr ) typeErr.classList.toggle( 'err', ! S.service.type );
	if ( descErr ) descErr.classList.toggle( 'err', desc.length < 20 );

	if ( ! S.service.type || desc.length < 20 ) return;

	S.service.description = desc;
	gp( 4 );

	// Auto-trigger AI analysis when entering Triage step.
	if ( typeof window.ProbotSoumStartTriage === 'function' && ! S.service.analysisComplete ) {
		window.ProbotSoumStartTriage();
	}
}

// nx4 — leaving the AI Triage step (service flow only). Requires a complete
// estimate, then advances to Date and renders the calendar.
//
// Service flow doesn't go through the maintenance robot-driven duration
// (computeDuration). Feed S.duration from the AI's hour estimate so the
// calendar can highlight the right multi-day range when the user picks
// a start date (e.g. 32 h ≈ 4 days → 4 cells highlighted).
export function nx4_triage() {
	if ( ! S.service.analysisComplete || ! ( S.service.estimatedHours > 0 ) ) return;
	S.duration = Math.max( 1, Math.ceil( S.service.estimatedHours / HOURS_PER_DAY ) );
	// If the user already picked a date earlier (then went back to retune the
	// description and got a different estimate), re-derive endDate + refresh
	// the picked-range UI so the calendar matches the new duration.
	if ( S.selDate ) {
		recomputeEndDate();
		updateDateUI();
	}
	gp( 5 );
	renderQCal();
}

function fmtDateISO( d ) {
	if ( ! d ) return '';
	var y  = d.getFullYear();
	var m  = ( '0' + ( d.getMonth() + 1 ) ).slice( -2 );
	var dd = ( '0' + d.getDate() ).slice( -2 );
	return y + '-' + m + '-' + dd;
}

function buildSubmitPayload() {
	var isService = S.quoteType === 'service';
	var modelIds = isService ? [] : Object.keys( S.selModels ).filter( function ( id ) { return ( S.selModels[ id ] || 0 ) > 0; } );
	var modeleLbl = isService
		? ( S.service.type || 'service' )
		: modelIds.map( function ( id ) { return S.selModels[ id ] + '× ' + id; } ).join( ', ' );
	var totalQty  = isService ? 0 : modelIds.reduce( function ( a, id ) { return a + ( S.selModels[ id ] || 0 ); }, 0 );
	var ac = S.addressComponents || {};
	var base = {
		quote_type:    S.quoteType || 'maintenance',
		service_type:        isService ? ( S.service.type || '' ) : '',
		service_description: isService ? ( S.service.description || '' ) : '',
		service_conversation: isService ? S.service.conversation : [],
		service_estimated_hours: isService ? ( S.service.estimatedHours || 0 ) : 0,
		service_confidence:  isService ? ( S.service.confidence || '' ) : '',
		service_summary:     isService ? ( S.service.summary || '' ) : '',
	};
	return Object.assign( base, {
		firstName:     $( 'inFname' ).value.trim(),
		lastName:      $( 'inLname' ).value.trim(),
		nom:           ( $( 'inFname' ).value.trim() + ' ' + $( 'inLname' ).value.trim() ).trim(),
		jobTitle:      $( 'inTitle' ).value.trim(),
		poste:         $( 'inTitle' ).value.trim(),
		telephone:     $( 'inTel' ).value.trim(),
		courriel:      $( 'inEmail' ).value.trim(),
		entreprise:    $( 'inCo' ).value.trim(),
		client_code:   ( $( 'inClientCode' ) ? $( 'inClientCode' ).value.trim().toUpperCase() : '' ),
		ville:         $( 'inFactoryAddress' ).value.trim(),
		addr_street:   ac.street       || '',
		addr_city:     ac.city         || '',
		addr_state:    ac.state_short  || '',
		addr_zip:           ac.zip           || '',
		addr_country:       ac.country       || '',
		addr_country_code:  ac.country_short || '',
		modele:        modeleLbl,
		qty:           totalQty,
		models_detail: S.selModels,
		sizesById:     S.sizeByRow,
		robotSize:     S.robotSize || '',
		otherDetail:   Object.keys( S.otherText || {} ).map( function ( k ) { return S.otherText[ k ]; } ).filter( Boolean ).join( ' / ' ),
		date:          fmtDateISO( S.selDate ),
		endDate:       fmtDateISO( S.endDate ),
		estimatedDays: S.duration,
		is_weekend:    !! S.surcharges.weekend,
		is_urgent:     !! S.surcharges.urgence,
		// `is_holiday` carries both real stat-holidays and "urgent <14d" so
		// the existing backend surcharge applies to both cases. The backend
		// only has surcharge_holiday_pct (no surcharge_urgent_pct yet); we
		// can split them later if the company wants distinct rates.
		is_holiday:    !! ( S.surcharges.holiday || S.surcharges.urgence ),
		training_required: !! S.surcharges.training,
		early_discount: 0,
		airport:       ( S.airport && S.airport.c ) ? S.airport.c : '',
		transport_mode: ( S.airport && S.airport.mode === 'drive' ) ? 'drive' : ( ( S.airport && S.airport.c ) ? 'fly' : '' ),
		drive_km:      ( S.airport && S.airport.driveKm ) ? S.airport.driveKm : 0,
		drive_minutes: ( S.airport && S.airport.driveMinutes ) ? S.airport.driveMinutes : 0,
		lang:          S.lang,
		utm_source:    UTM.utm_source,
		utm_medium:    UTM.utm_medium,
		utm_campaign:  UTM.utm_campaign,
		utm_content:   UTM.utm_content,
		utm_term:      UTM.utm_term,
		gclid:         UTM.gclid,
		fbclid:        UTM.fbclid,
		// v1.1.53 — Click IDs additionnels + referrer pour HubSpot deal tracking
		msclkid:       UTM.msclkid,
		li_fat_id:     UTM.li_fat_id,
		referrer:      UTM.referrer,
		landing_page:  UTM.landing_page,
		website:       ( $( 'inWebsite' ) || {} ).value || '',
		// v1.0.94 — Consentements (Loi 25 / PIPEDA / CAN-SPAM)
		terms_accepted:     !! ( $( 'psConsentTerms' )     && $( 'psConsentTerms' ).checked ),
		marketing_consent:  !! ( $( 'psConsentMarketing' ) && $( 'psConsentMarketing' ).checked ),
		// v1.0.95 — Phone vérifié via Twilio Verify (SMS OTP)
		phone_verified:     !! S.phoneVerified,
		phone_e164:         S.phoneE164 || '',
	} );
}

export function nx3() {
	if ( ! S.selDate ) {
		var err = $( 'dateErr' );
		if ( err ) err.classList.add( 'on' );
		return;
	}
	// v1.0.97 — T&C consent moved to Step 1 (psConsentTerms validated dans nx1).
	// On lit néanmoins l'état de la checkbox pour le payload buildSubmitPayload :
	// si l'utilisateur a fait Back depuis Step 3 et décoché, on bloque ici aussi.
	var termsCb = $( 'psConsentTerms' );
	if ( termsCb && ! termsCb.checked ) {
		alert( S.lang === 'fr'
			? 'Vous devez accepter les Termes et Conditions à l\'étape Contact pour soumettre.'
			: 'You must accept the Terms and Conditions at the Contact step to submit.' );
		return;
	}

	// btn used pour visual loading state. Service flow utilise btnNx5,
	// maintenance flow utilise btnNx3 — on accepte les deux.
	var btn = $( 'btnNx5' ) || $( 'btnNx3' );
	var fr  = S.lang === 'fr';
	var origTxt = btn ? btn.innerHTML : '';
	if ( btn ) {
		btn.disabled  = true;
		btn.innerHTML = '<span class="spin" style="border-color:rgba(255,255,255,.3);border-top-color:#fff;vertical-align:middle;margin-right:6px"></span>' +
			( fr ? 'Envoi en cours…' : 'Submitting…' );
	}

	apiPost( 'submit', buildSubmitPayload(), { recaptchaAction: 'submit' } )
		.then( function ( res ) {
			if ( ! res || ! res.success ) {
				var msg = ( res && res.error ) ? res.error : ( fr ? 'Erreur lors de l\'envoi.' : 'Submission error.' );
				alert( msg );
				if ( btn ) { btn.disabled = false; btn.innerHTML = origTxt; }
				return;
			}
			var ref = res.data && res.data.ref ? res.data.ref : '';
			var refEl = $( 'sucRef' );
			if ( refEl ) {
				refEl.innerHTML = '';
				if ( ref ) {
					var prefix = document.createElement( 'span' );
					prefix.textContent = ( fr ? 'Référence : ' : 'Reference: ' );
					var strong = document.createElement( 'strong' );
					strong.textContent = ref;
					refEl.appendChild( prefix );
					refEl.appendChild( strong );
				}
			}

			// v1.1.53 — Conversion events vers les plateformes ads/analytics.
			// On push dans tous les containers présents — si l'admin n'a pas
			// installé GTM/GA4/Pixel, les calls sont no-op silencieux.
			try {
				var quoteType = ( document.querySelector( '.probot-soum' ) || {} ).getAttribute
					? document.querySelector( '.probot-soum' ).getAttribute( 'data-quote-type' )
					: 'maintenance';
				var totalEstime = ( res.data && res.data.total ) || 0;
				var currency    = ( res.data && res.data.currency ) || 'CAD';
				var commonProps = {
					form_type:  quoteType || 'maintenance',
					reference:  ref,
					value:      totalEstime,
					currency:   currency,
				};

				// 1) Google Tag Manager dataLayer — pour que l'admin puisse
				//    déclencher des tags GA4/Ads/Pixel via GTM sans recoder ici.
				if ( window.dataLayer && typeof window.dataLayer.push === 'function' ) {
					window.dataLayer.push( Object.assign( {
						event: 'probot_lead_submitted',
					}, commonProps ) );
				}

				// 2) GA4 — v1.1.114 : RETIRÉ le gtag('generate_lead') navigateur.
				//    Le funnel GA4 est géré SERVER-SIDE (class-server-conversions) :
				//    generate_lead aux coordonnées + submit_quote à la soumission avec
				//    la vraie valeur. GA4 ne déduplique PAS navigateur vs serveur →
				//    garder ce gtag doublait le generate_lead (observé : =2). Le pixel
				//    navigateur (GTM / plugin) ne fait plus que PageView + retargeting.

				// 3) Meta — v1.1.113 : RETIRÉ l'appel fbq('track','Lead') navigateur.
				//    Les conversions Meta passent maintenant par la Conversions API
				//    server-side (class-server-conversions.php) qui a la VRAIE valeur
				//    + l'attribution. Garder ce fbq ici doublerait l'event Lead une
				//    fois le pixel base chargé (via GTM) → conversions gonflées sans
				//    déduplication. Le pixel base ne fait que PageView + retargeting.

				// 4) LinkedIn Insight Tag — conversion event.
				//    Note : LinkedIn requiert un conversion_id (configuré dans
				//    Campaign Manager). On expose dans dataLayer pour GTM.
				if ( typeof window.lintrk === 'function' ) {
					try { window.lintrk( 'track', { conversion_id: 0 } ); } catch ( e ) {}
				}
			} catch ( e ) {
				// Tracking est best-effort — on ne casse jamais la conversion
				// utilisateur si analytics tombe.
				console.warn( 'Probot tracking event failed:', e );
			}

			gp( 4 );
		} )
		.catch( function () {
			alert( fr ? 'Erreur réseau — réessayez.' : 'Network error — please retry.' );
			if ( btn ) { btn.disabled = false; btn.innerHTML = origTxt; }
		} );
}
